import { ArrowRightOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, Radio } from "antd";
import styles from "../../shared/Evaluaciones.module.css";

export function BuscadorEvaluaciones({ tipo, texto, cargando, onTexto, onTipo, onBuscar }) {
  return (
    <section className={styles.searchPanel}>
      <div className={styles.label}>01 / BUSCAR POR</div>
      <Radio.Group
        value={tipo}
        onChange={event => onTipo(event.target.value)}
        optionType="button"
        buttonStyle="solid"
        options={[
          { label: "Empleado", value: "empleado" },
          { label: "Servicio", value: "servicio" },
        ]}
      />
      <form className={styles.search} onSubmit={onBuscar}>
        <Input
          aria-label={`Buscar ${tipo}`}
          prefix={<SearchOutlined />}
          value={texto}
          onChange={event => onTexto(event.target.value)}
          placeholder={tipo === "empleado" ? "Clave de empleado o Correo" : "Folio del servicio"}
          allowClear
        />
        <Button type="primary" htmlType="submit" loading={cargando}>
          Buscar <ArrowRightOutlined />
        </Button>
      </form>
      <p className={styles.hint}>
        Deja el campo vacío y presiona Buscar para ver todos los registros.
      </p>
    </section>
  );
}
